<template>
    <v-dialog
        v-model="dialog"
        width="1200px"
    >
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="primary"
            text
            small
            v-bind="attrs"
            v-on="on"
        >
            <v-icon left color="blue-grey">mdi-link-box-outline</v-icon>
            <span class="blue-grey--text">Node Description</span>
        </v-btn>
        </template>
        <v-card>
        <v-card-title>
            Node Description
        </v-card-title>
        <v-card-text>
            <v-card class="pa-3">
                <template v-for="(item, index) in items">
                    <div :key="item.id">
                        <p>| {{index + 1}} || [[<span class="data-word">{{item.nodeDescription.id}}</span>]] || <span class="data-word">{{item.nodeDescription.class}}</span> || <span class="data-word">{{item.nodeDescription.groupName}}</span> || <span class="data-word">{{item.nodeDescription.partName}}</span> || <span class="data-word">{{item.nodeDescription.label}}</span>|| <span class="data-word">{{item.nodeDescription.hangeul}}</span> || <span class="data-word">{{item.nodeDescription.hanja}}</span> || <span class="data-word">{{item.nodeDescription.english}}</span> || http://dh.aks.ac.kr/hanyang2/wiki/index.php/<span class="data-word">{{item.nodeDescription.id}}</span> || <span class="data-word">{{item.nodeDescription.iconUrl}}</span> || <span v-if="item.complete" class="data-word">O</span><span v-else class="data-word">△</span> ||  ||  ||</p>
                        <p>|-</p>
                    </div>
                </template>
            </v-card> 
        </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: [ 'items' ],
    data() {
        return {
            dialog: false
        }
    },


}
</script>

<style>

</style>